import type { TranslationTag } from '@ps/web-core-intl';
import { Translation } from '@ps/web-shared-components';
import type { ReactElement } from 'react';
import React from 'react';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';

import styles from './Tile.scss';

export interface TileTranslationProps {
  translation?: TranslationTag;
  value?: number;
  numberOfPlay?: number;
}

const TileTranslation: React.FC<TileTranslationProps> = ({ translation, value, numberOfPlay }) => {
  if (!translation) return null;
  if (!value) return <Translation tagName="span" {...translation} />;
  const values: Record<number, ReactElement | number> = {
    0: (
      <span className={styles.buyIn}>
        <CurrencyAmount style="currency" value={value} currency="USD" currencyDisplay="symbol" />
      </span>
    )
  };
  if (numberOfPlay) {
    values[1] = numberOfPlay;
  }

  return <Translation tagName="span" {...translation} values={values} />;
};

export default TileTranslation;
